// FEAT-056(#560): 라이선스 제품 헬퍼. 데이터는 actions/constants/LicenseProductConstant.js.
import { LICENSE_PRODUCTS, DEFAULT_LICENSE_PRODUCT } from '../actions/constants/LicenseProductConstant';

const safeCallerCompanyId = (getState) => {
    try {
        return getState?.()?.AuthReducer?.user?.companyId ?? null;
    } catch (_e) {
        return null;
    }
};

// product 가 undefined/null 이면 기본 제품. key 로 목록의 정본 객체를 반환, 목록 밖이면 null(+warn).
export const resolveLicenseProduct = (product, { handler, getState } = {}) => {
    if (product === undefined || product === null) return DEFAULT_LICENSE_PRODUCT;
    const key = product?.key;
    const found = LICENSE_PRODUCTS.find((p) => p.key === key);
    if (found) return found;
    console.warn('[licenseProduct] unknown license product', {
        handler,
        callerCompanyId: safeCallerCompanyId(getState),
        target: key ?? null,
        reason: 'product is not in LICENSE_PRODUCTS',
    });
    return null;
};

export const hasPcActivation = (product) => Boolean(product?.pcActivation?.localAppId);

// 화면·훅이 PC 활성화 UI·요청을 켤지 정하는 단일 판정 — 생략은 SMARTDent, 목록 밖은 warn 후 false.
// guardPcActivation 과 달리 미지원 제품을 경고하지 않는다(그 제품 화면을 여는 것은 정상 경로).
export const isPcActivationEnabled = (product, { handler, getState } = {}) =>
    hasPcActivation(resolveLicenseProduct(product, { handler, getState }));

// PC 활성화를 지원하는 제품의 정본 객체만 반환. 아니면 null(+warn).
export const guardPcActivation = (product, { handler, getState } = {}) => {
    const resolved = resolveLicenseProduct(product, { handler, getState });
    if (!resolved) return null;
    if (!hasPcActivation(resolved)) {
        console.warn('[licenseProduct] pc activation not supported', {
            handler,
            callerCompanyId: safeCallerCompanyId(getState),
            target: resolved.key,
            reason: 'product has no pcActivation',
        });
        return null;
    }
    return resolved;
};
